import { createAction } from "@reduxjs/toolkit"

export const setModel = createAction('delivery/setModel')
export const addRoute = createAction('delivery/addRoute')
export const deleteRoute = createAction('delivery/deleteRoute')
export const clearRoute = createAction('delivery/clearRoute')
export const setBack = createAction('delivery/setBack')
export const setHelp = createAction('delivery/setHelp')
export const atualizeDelivery = createAction('delivery/atualizeDelivery')
export const setAnotherModel = createAction('delivery/setAnotherModel')